import React, { useEffect, useState } from "react";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { closeModal, ToastMain, SweetAlertShow } from "../master/Master";
import {
  GetHostelList,
  HostelBedsList,
  HostelRoomList,
  HostelStudentDelete,
  HostelStudentList,
  HostelStudentStatusChange,
  HostelStudentUpdate,
} from "../../api/HostelService";
import Swal from "sweetalert2";
import { Link, useLocation } from "react-router-dom";
import WelcomeBar from "./WelcomeBar";
import usePrivateLink from "../config/usePrivateLink";

export default function Students() {
  const [loading, setLoading] = useState(false);
  const [hostels, setHostels] = useState("");
  const [beds, setBeds] = useState("");
  const [rooms, setRooms] = useState("");
  const [students, setStudents] = useState("");
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hostelId, setHostelID] = useState("");
  const [roomId, setRoomID] = useState("");
  const [bedId, setBedID] = useState("");
  const [modalData, setModalData] = useState("");
  const [hostel_id, setHostelId] = useState(localStorage.getItem("hostel_id"));
  const [status, setStatus] = useState("1");
  useEffect(() => {
    const handleStorageChange = () => {
      setHostelId(localStorage.getItem("hostel_id"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getHostelList = async () => {
    setLoading(true);
    let addUrl = "";
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    try {
      const response = await GetHostelList(addUrl);
      if (response.data?.status) {
        setHostels(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getHostelRoomsList = async () => {
    setLoading(true);
    let addUrl = "";
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    try {
      const response = await HostelRoomList(addUrl);
      if (response.data?.status) {
        setRooms(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getHostelBedsList = async () => {
    setLoading(true);
    let addUrl = "";
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    try {
      const response = await HostelBedsList(addUrl);
      if (response.data?.status) {
        setBeds(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelStudents = async () => {
    setLoading(true);
    let addUrl = `&page=${page}`;
    if (search) addUrl += `&search=${search}`;
    if (hostelId) addUrl += `&hostel_id=${hostelId}`;
    if (roomId) addUrl += `&room_id=${roomId}`;
    if (bedId) addUrl += `&bed_id=${bedId}`;
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    if (status) addUrl += `&status=${status}`;
    try {
      const response = await HostelStudentList(addUrl);
      if (response.data?.status) {
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHostelList();
    getHostelRoomsList();
    getHostelBedsList();
  }, []);

  useEffect(() => {
    getHostelStudents();
  }, [hostelId, roomId, bedId, status, search]);

  const updateHostelStudent = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await HostelStudentUpdate(formData);
      if (response?.data?.status) {
        closeModal("editStudent");
        getHostelStudents();
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const updateHostelStudentStatus = async (id, end_date) => {
    try {
      const response = await HostelStudentStatusChange(id, end_date);
      if (response?.data?.status) {
        getHostelStudents();
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const deleteHostelStudent = async (id) => {
    setLoading(true);
    try {
      const response = await HostelStudentDelete(id);
      if (response?.data?.status) {
        getHostelStudents();
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const hasAccess = usePrivateLink();

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <WelcomeBar />
                <div className="card hostel-students-toolbar my-3">
                  <div className="card-body">
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4 border-bottom pb-3">
                      <div>
                        <span className="hostel-page-kicker">
                          Hostel Students
                        </span>
                        <h4 className="mb-1">Students</h4>
                        <p className="text-muted mb-0">
                          Search, filter and manage hostel student records.
                        </p>
                      </div>
                      {hasAccess("/hostel/student/add") && (
                        <Link
                          to={"/hostel/student/add"}
                          className="btn btn-primary"
                        >
                          <i className="ri-add-line me-1"></i>
                          Add New Student
                        </Link>
                      )}
                    </div>
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-3 col-md-6">
                        <div className="form-floating form-floating-outline">
                          <select
                            name="room_id"
                            id="room_id"
                            className="form-select"
                            value={roomId}
                            onChange={(e) => setRoomID(e.target.value)}
                          >
                            <option value="">All</option>
                            {hostel_id &&
                              rooms?.data
                                ?.filter((r) => r?.hostel_id == hostel_id)
                                ?.map((room, i) => (
                                  <option value={room?.id}>
                                    {room?.room_no}
                                  </option>
                                ))}
                          </select>
                          <label htmlFor=""> Select Room </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-floating form-floating-outline">
                          <select
                            name="bed_id"
                            id="bed_id"
                            className="form-select"
                            value={bedId}
                            onChange={(e) => setBedID(e.target.value)}
                          >
                            <option value="">All</option>
                            {hostel_id &&
                              roomId &&
                              beds?.data
                                ?.filter((b) => b?.hostel_id == hostel_id)
                                ?.filter((b) => b?.room_id == roomId)
                                ?.map((bed, i) => (
                                  <option value={bed?.id}>{bed?.bed_no}</option>
                                ))}
                          </select>
                          <label htmlFor=""> Select Bed </label>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Search By Bed No/Room No"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <label htmlFor="">Search </label>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-6">
                        <button
                          type="button"
                          onClick={() => {
                            setSearch("");
                            setHostelID("");
                            setRoomID("");
                            setStatus("1");
                          }}
                          className="btn btn-label-secondary w-100"
                        >
                          <i className="ri-restart-line me-1"></i>
                          Reset
                        </button>
                      </div>
                    </div>

                    <div className="hostel-status-tabs mt-4">
                      <ul className="nav nav-pills gap-2">
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === "1"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => {
                              setStatus("1");
                              setPage(1);
                            }}
                          >
                            Active
                          </button>
                        </li>

                        <li className="nav-item">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === "2"
                                ? "btn-danger"
                                : "btn-outline-danger"
                            }`}
                            onClick={() => {
                              setStatus("2");
                              setPage(1);
                            }}
                          >
                            Inactive
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card hostel-students-list-card my-3">
                  <div className="card-body">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-4">
                      <div>
                        <h5 className="mb-1">Student Directory</h5>
                        <p className="text-muted small mb-0">
                          Showing {students?.from || 0} to {students?.to || 0}{" "}
                          of {students?.total || 0} entries
                        </p>
                      </div>
                      <span
                        className={`hostel-filter-pill ${
                          status === "1" ? "is-active" : "is-inactive"
                        }`}
                      >
                        {status === "1" ? "Active records" : "Inactive records"}
                      </span>
                    </div>

                    {students?.data?.length > 0 ? (
                      <div className="hostel-student-list">
                        {students?.data?.map((student, index) => (
                          <div className="hostel-student-row" key={student?.id}>
                            {/* TOP ROW */}
                            <div className="hostel-student-header">
                              {/* Student Identity */}
                              <div className="hostel-student-identity">
                                <div className="d-flex align-items-center gap-3 min-w-0">
                                  <span className="student-index">
                                    {index + 1}
                                  </span>

                                  <div className="student-avatar">
                                    <i className="ri-user-3-line"></i>
                                  </div>

                                  <div className="min-w-0">
                                    <h6 className="student-name mb-1">
                                      {student?.student_name || "-"}
                                    </h6>

                                    <span className="student-registration">
                                      {student?.registration_no ||
                                        "No registration"}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Status + Actions */}
                              <div className="student-row-controls">
                                {hasAccess("/hostel/student/status") && (
                                <button
                                  className={`student-status-btn ${
                                    student?.status === "1"
                                      ? "status-active"
                                      : "status-inactive"
                                  }`}
                                  disabled={student?.status === "2"}
                                  onClick={async () => {
                                    if (student?.status === "1") {
                                      const today = new Date()
                                        .toISOString()
                                        .split("T")[0];

                                      const { value: end_date } =
                                        await Swal.fire({
                                          title: "Mark as Inactive",
                                          text: "Select end date to mark this student as Inactive",
                                          icon: "warning",
                                          input: "date",
                                          inputLabel: "End date",
                                          inputValue: today,
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText:
                                            "Yes, Inactivate it!",
                                          inputValidator: (value) => {
                                            if (!value) {
                                              return "You need to select a date!";
                                            }
                                          },
                                        });

                                      if (end_date) {
                                        updateHostelStudentStatus(
                                          student?.id,
                                          end_date,
                                        );
                                      }
                                    }
                                  }}
                                >
                                  <span className="status-dot"></span>

                                  {student?.status === "1"
                                    ? "Active"
                                    : "Inactive"}
                                </button>
                                )}

                                <div className="student-actions">
                                  {hasAccess("/hostel/student/profile") && (
                                    <Link
                                      to={`/hostel/profile?id=${student.id}`}
                                      className="student-action-btn action-view"
                                    >
                                      <i className="ri-eye-line"></i>
                                      <span>View</span>
                                    </Link>
                                  )}

                                  {hasAccess("/hostel/student/edit") && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setModalData(student);
                                      }}
                                      className="student-action-btn action-edit"
                                      data-bs-toggle="modal"
                                      data-bs-target="#editStudent"
                                    >
                                      <i className="ri-pencil-line"></i>
                                      <span>Edit</span>
                                    </button>
                                  )}

                                  {hasAccess("/hostel/student/delete") && (
                                    <button
                                      type="button"
                                      className="student-action-btn action-delete"
                                      onClick={() =>
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "This action will permanently delete !",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#d33",
                                          cancelButtonColor: "#6c757d",
                                          confirmButtonText: "Yes, delete it!",
                                          cancelButtonText: "Cancel",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            deleteHostelStudent(student?.id);
                                          }
                                        })
                                      }
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                      <span>Delete</span>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* STUDENT DETAILS */}
                            <div className="student-detail-grid">
                              <div className="student-detail-item">
                                <span>Father</span>
                                <strong title={student?.father_name || "-"}>
                                  {student?.father_name || "-"}
                                </strong>
                              </div>

                              <div className="student-detail-item">
                                <span>Mobile</span>
                                <strong>{student?.mobile || "-"}</strong>
                              </div>

                              <div className="student-detail-item">
                                <span>Room & Bed</span>
                                <strong>
                                  {student?.bed?.bed_no || "-"} (
                                  {student?.room?.room_no || "-"})
                                </strong>
                              </div>

                              <div className="student-detail-item">
                                <span>Joining</span>
                                <strong>{student?.joining_date || "-"}</strong>
                              </div>

                              <div className="student-detail-item student-address">
                                <span>Address</span>
                                <strong title={student?.address || "-"}>
                                  {student?.address || "-"}
                                </strong>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="student-empty-state">
                        <div className="student-empty-icon">
                          <i className="ri-user-search-line"></i>
                        </div>
                        <h5 className="mb-1">No students found</h5>
                        <p className="text-muted mb-0">
                          Try changing the filters or search keyword.
                        </p>
                      </div>
                    )}

                    <nav
                      aria-label="Page navigation"
                      className="student-pagination"
                    >
                      <ul className="pagination pagination-sm mb-0">
                        {students?.links?.map((btn, i) => (
                          <li
                            className={`page-item  ${
                              btn?.active && "active"
                            }  ${btn?.url ? "" : "disabled"} `}
                          >
                            <button
                              className="page-link waves-effect"
                              onClick={() => {
                                if (students?.links?.length === i + 1) {
                                  btn?.url &&
                                    setPage(students?.current_page + 1);
                                } else if (i === 0) {
                                  btn?.url &&
                                    setPage(students?.current_page - 1);
                                } else {
                                  setPage(btn.label);
                                }
                              }}
                            >
                              {students?.links?.length == i + 1 ? (
                                <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                              ) : i == 0 ? (
                                <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                              ) : (
                                btn?.label
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hostel-students-toolbar,
        .hostel-students-list-card {
          border: 1px solid var(--bs-border-color);
          border-radius: 10px;
          background-color: var(--bs-card-bg, var(--bs-body-bg));
          box-shadow: var(--bs-box-shadow-sm, 0 2px 8px rgba(0, 0, 0, 0.05));
          overflow: hidden;
        }

        .hostel-page-kicker {
          display: inline-flex;
          margin-bottom: 0.35rem;
          color: var(--bs-secondary-color);
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0;
          text-transform: uppercase;
        }

        .hostel-status-tabs .btn {
          min-width: 96px;
          border-radius: 999px;
          font-weight: 600;
        }

        .hostel-filter-pill {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: fit-content;
          padding: 0.45rem 0.75rem;
          border-radius: 999px;
          font-size: 0.8125rem;
          font-weight: 700;
        }

        .hostel-filter-pill.is-active {
          color: var(--bs-success);
          background-color: rgba(var(--bs-success-rgb), 0.12);
        }

        .hostel-filter-pill.is-inactive {
          color: var(--bs-danger);
          background-color: rgba(var(--bs-danger-rgb), 0.12);
        }

        .hostel-student-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

        .hostel-student-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.9rem;
  padding: 1rem 1.1rem;
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  background:
    linear-gradient(
      180deg,
      rgba(var(--bs-body-color-rgb), 0.025),
      rgba(var(--bs-body-color-rgb), 0)
    ),
    var(--bs-card-bg, var(--bs-body-bg));

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

        .hostel-student-row:hover {
  transform: translateY(-1px);
  border-color: rgba(var(--bs-primary-rgb), 0.3);
  box-shadow:
    0 4px 14px rgba(var(--bs-body-color-rgb), 0.07);
}

.hostel-student-header {
  display: grid;
  grid-template-columns: minmax(250px, 1fr) auto;
  align-items: center;
  gap: 1.5rem;
}

        .hostel-student-identity {
  min-width: 0;
}

        .student-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  width: 34px;
  height: 34px;

  border-radius: 9px;

  color: var(--bs-secondary-color);
  background-color:
    rgba(var(--bs-body-color-rgb), 0.055);

  font-size: 0.8125rem;
  font-weight: 700;
}

        .student-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  width: 44px;
  height: 44px;

  border-radius: 11px;

  color: var(--bs-primary);
  background-color:
    rgba(var(--bs-primary-rgb), 0.12);

  font-size: 1.3rem;
}

       .student-name {
  color: var(
    --bs-heading-color,
    var(--bs-body-color)
  );

  font-size: 1rem;
  font-weight: 700;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

       .student-registration {
  display: block;

  color: var(--bs-secondary-color);

  font-size: 0.8rem;
  font-weight: 600;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

        .student-status-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 0.4rem;

  min-width: 92px;
  height: 34px;

  padding: 0.4rem 0.75rem;

  border: 0;
  border-radius: 999px;

  font-size: 0.8rem;
  font-weight: 700;

  white-space: nowrap;
}

       .student-status-btn.status-active {
  color: var(--bs-success);

  background-color:
    rgba(var(--bs-success-rgb), 0.13);
}

       .student-status-btn.status-inactive {
  color: var(--bs-danger);

  background-color:
    rgba(var(--bs-danger-rgb), 0.13);
}

        .student-status-btn:disabled {
          opacity: 1;
        }

       .status-dot {
  width: 7px;
  height: 7px;

  flex: 0 0 auto;

  border-radius: 50%;

  background-color: currentColor;
}

        .student-detail-grid {
  display: grid;

  grid-template-columns:
    minmax(110px, 0.9fr)
    minmax(110px, 0.8fr)
    minmax(120px, 0.85fr)
    minmax(120px, 0.8fr)
    minmax(200px, 1.5fr);

  gap: 1rem;

  min-width: 0;

  padding-top: 0.9rem;

  border-top: 1px solid
    rgba(var(--bs-body-color-rgb), 0.07);
}

        .student-detail-item {
          min-width: 0;
        }

        .student-detail-item span {
  display: block;

  margin-bottom: 0.2rem;

  color: var(--bs-secondary-color);

  font-size: 0.67rem;
  font-weight: 700;

  letter-spacing: 0.02em;
  text-transform: uppercase;
}

        .student-detail-item strong {
  display: block;

  color: var(
    --bs-heading-color,
    var(--bs-body-color)
  );

  font-size: 0.82rem;
  font-weight: 650;

  line-height: 1.4;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

       .student-address {
  min-width: 0;
}

.student-address strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

        .student-row-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 0.65rem;

  min-width: max-content;
}

        .student-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

        .student-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 0.35rem;

  min-width: 68px;
  height: 34px;

  padding: 0.4rem 0.7rem;

  border: 1px solid var(--bs-border-color);
  border-radius: 8px;

  background-color:
    var(--bs-card-bg, var(--bs-body-bg));

  font-size: 0.8rem;
  font-weight: 700;

  text-decoration: none;

  white-space: nowrap;

  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    transform 0.2s ease;
}

        .student-action-btn i {
          font-size: 1rem;
          line-height: 1;
        }

        .student-action-btn:hover,
        .student-action-btn:focus {
          transform: translateY(-1px);
          text-decoration: none;
        }

        .student-action-btn.action-view {
          color: var(--bs-info);
          border-color: rgba(var(--bs-info-rgb), 0.32);
          background-color: rgba(var(--bs-info-rgb), 0.1);
        }

        .student-action-btn.action-edit {
          color: var(--bs-primary);
          border-color: rgba(var(--bs-primary-rgb), 0.32);
          background-color: rgba(var(--bs-primary-rgb), 0.1);
        }

        .student-action-btn.action-delete {
          color: var(--bs-danger);
          border-color: rgba(var(--bs-danger-rgb), 0.32);
          background-color: rgba(var(--bs-danger-rgb), 0.1);
        }

        .student-empty-state {
          padding: 3rem 1rem;
          text-align: center;
          border: 1px dashed var(--bs-border-color);
          border-radius: 10px;
          background-color: rgba(var(--bs-body-color-rgb), 0.018);
        }

        .student-empty-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 64px;
          margin-bottom: 1rem;
          border-radius: 50%;
          color: var(--bs-primary);
          background-color: rgba(var(--bs-primary-rgb), 0.12);
          font-size: 1.75rem;
        }

        .student-pagination {
          display: flex;
          justify-content: flex-end;
          margin-top: 1.25rem;
        }

        .student-pagination .page-link {
          border-color: var(--bs-border-color);
        }

        @media (max-width: 767px) {

  .hostel-student-row {
    padding: 0.9rem;
  }

  .hostel-student-header {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .student-row-controls {
    flex-direction: column;
    align-items: stretch;

    width: 100%;

    padding-top: 0.85rem;

    border-top: 1px solid
      rgba(var(--bs-body-color-rgb), 0.07);
  }

  .student-status-btn {
    width: 100%;
  }

  .student-actions {
    display: grid;

    grid-template-columns:
      repeat(3, minmax(0, 1fr));

    width: 100%;
  }

  .student-action-btn {
    width: 100%;
    min-width: 0;
  }

  .student-detail-grid {
    grid-template-columns:
      repeat(2, minmax(0, 1fr));

    gap: 0.85rem;
  }

  .student-address {
    grid-column: 1 / -1;
  }

  .student-name {
    font-size: 0.95rem;
  }
}

        @media (min-width: 768px) and (max-width: 1199px) {

  .hostel-student-header {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .student-row-controls {
    justify-content: flex-start;

    padding-top: 0.75rem;

    border-top: 1px solid
      rgba(var(--bs-body-color-rgb), 0.07);
  }

  .student-detail-grid {
    grid-template-columns:
      repeat(3, minmax(0, 1fr));
  }

  .student-address {
    grid-column: 1 / -1;
  }
}
      `}</style>

      <div
        className="modal fade"
        id="editStudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={updateHostelStudent}>
              <div className="modal-header bg-label-primary py-3">
                <h3 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Student
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-3 p-3">
                  <input type="hidden" name="id" value={modalData?.id} />
                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-capitalize"
                      placeholder="Student Name"
                      name="student_name"
                      defaultValue={modalData?.student_name}
                    />
                    <label className="">Student Name</label>
                    <span className="text-danger">
                      {error?.student_name ?? ""}
                    </span>
                  </div>
                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Student Registration No"
                      name="registration_no"
                      required
                      defaultValue={modalData?.registration_no}
                    />
                    <label className="">Registration No</label>
                    <span className="text-danger">
                      {error?.registration_no ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-uppercase"
                      placeholder="Father Name"
                      name="father_name"
                      defaultValue={modalData?.father_name}
                    />
                    <label className="">Father Name</label>
                    <span className="text-danger">
                      {error?.father_name ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Contact Number"
                      name="mobile"
                      defaultValue={modalData?.mobile}
                    />
                    <label className="">Contact No</label>
                    <span className="text-danger">{error?.mobile ?? ""}</span>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Aadhar Number"
                      name="aadhar_no"
                      defaultValue={modalData?.aadhar_no}
                    />
                    <label className="">Aadhar No</label>
                    <span className="text-danger">
                      {error?.aadhar_no ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-uppercase"
                      placeholder="Address"
                      name="address"
                      defaultValue={modalData?.address}
                    />
                    <label className="">Address</label>
                    <span className="text-danger">{error?.address ?? ""}</span>
                  </div>

                  <div className="col-md-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Joining Date"
                      name="joining_date"
                      defaultValue={modalData?.joining_date}
                    />
                    <label className="">Joining Date</label>
                    <span className="text-danger">
                      {error?.joining_date ?? ""}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
